import React, { Component } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import { connect } from 'react-redux'
import TaskMenu from './task-menu'
import { updateTask } from 'state/actions'

import BrainModal from 'components/brain-modal/brain-modal'

import ProfilePicture from 'components/profile/profile-picture'

import copy from 'fast-copy'

import { createSelector } from 'reselect'

import {
	getCurrentUser,
	getCurrentAccount
} from 'state/selectors'

import isEqual from 'react-fast-compare'

class TaskPeople extends Component {
	state = {
		brainData: null
	}

	selectedUsersArray = []

	shouldComponentUpdate = (nextProps, nextState) => {
		const {
			peopleData,
			menuState,
			task
		} = this.props

		const taskId = task ? task.id : -1
		const newTaskId = nextProps.task ? nextProps.task.id : -2

		const hasMenuStatusChanged = menuState.currentFocusedTask == taskId || nextProps.menuState.currentFocusedTask == newTaskId

		const hasPeopleDataChanged = !isEqual(peopleData, nextProps.peopleData)
		const hasBrainDataChanged = !isEqual(this.state.brainData, nextState.brainData)

		const shouldUpdate = hasPeopleDataChanged || hasMenuStatusChanged || hasBrainDataChanged

		return shouldUpdate
	}

	isUserIdInTask = (user, userIdsArray) => {
		let isUserIdInTask = false

		if(userIdsArray.indexOf(user.id) !== -1){
			isUserIdInTask = true
		}

		return isUserIdInTask
	}

	closeBrainModal = (isActioned = false) => {
		const {
			clearTaskActivityHistory,
			milestone,
			updateTask,
			setBrainData,
			currentProject,
			column
		} = this.props

		if(!this.state.brainData.isVisible && !isActioned){
			return 
		}

		setBrainData(null)

		const brainData = copy(this.state.brainData)

		brainData.isVisible = false

		this.setState({
			brainData
		})

		clearTaskActivityHistory()

		if(isActioned){
			let updatedMilestone = copy(milestone)
			
			updatedMilestone.tasks.forEach((task, index) => {
				brainData.userIds.forEach(userId => {
					const columnData = task.column_data ? task.column_data : {}
					const taskUsers = columnData[column.id] ? columnData[column.id]: []
					const userIndex = taskUsers.indexOf(userId)

					if(userIndex === -1 && brainData.operation === 'ADD'){
						taskUsers.push(userId)
					}else if(brainData.operation === 'REMOVE' && userIndex !== -1){
						taskUsers.splice(userIndex, 1)
					}

					columnData[column.id] = taskUsers

					task.column_data = columnData
				})

				// just in case? not sure if necessary
				updatedMilestone.tasks[index] = task
			})

			// it'll automatically check whether it's an array.
			updateTask(updatedMilestone.tasks)
		}
	}

	assessActionableBehaviour = _ => {
		const {
			taskActivityHistory,
			task,
			openMenu,
			allUsers,
			milestone,
			setBrainData,
			column
		} = this.props

		if(milestone.tasks.length < 3 || !taskActivityHistory){
			return
		}

		const reversedActivityHistory = [
			...taskActivityHistory
		]

		reversedActivityHistory.reverse()

		let userIdsModifiedOnThisTask = []
		let userIdsModifiedOnPreviousTask = []
		let hasInvalidated = false
		let previousLoopedTaskId = null
		let previousLoopedOperation = null
		let previousTaskId = null
		let mostRecentOperation = null

		if(reversedActivityHistory.length){
			mostRecentOperation = reversedActivityHistory[0].activity
		}

		reversedActivityHistory.forEach(activity => {
			if(activity.type !== 'PERSON'){
				hasInvalidated = true
			}

			if(hasInvalidated){
				return
			}

			// from here we can assume it's in the same sequence of adding people
			if((!previousLoopedTaskId || previousLoopedTaskId === task.id) && activity.taskId === task.id && (!previousLoopedOperation || previousLoopedOperation === activity.activity)){
				if(activity.targetId){
					userIdsModifiedOnThisTask.push(activity.targetId)
				}
			}

			// If the task isn't this one, but we haven't set the previous, it's this.
			if(activity.taskId !== task.id && !previousTaskId){
				previousTaskId = activity.taskId
			}

			if(activity.taskId === previousTaskId && (!previousLoopedOperation || previousLoopedOperation === activity.activity)){
				if(activity.targetId){
					userIdsModifiedOnPreviousTask.push(activity.targetId)
				}
			}

			// at the end
			previousLoopedTaskId = activity.taskId
			previousLoopedOperation = activity.activity
		})

		if(userIdsModifiedOnThisTask.sort().join(',') === userIdsModifiedOnPreviousTask.sort().join(',')){
			let userNames = userIdsModifiedOnThisTask.map(userId => {
				const user = allUsers[userId]

				if(user){
					return user.first_name
				}
			})

			let userNamesString = ''

			userNames.forEach((name, index) => {
				if(!index){
					userNamesString += '<strong>'+name+'</strong>'
				}else if(index == (userNames.length - 1)){
					userNamesString += ' & <strong>'+name+'</strong>'
				}else{
					userNamesString += ', <strong>'+name+'</strong>'
				}
			})

			const normalisedOperation = mostRecentOperation == 'ADD' ? 'Add' : 'Remove'

			const suggestion = `${normalisedOperation} ${userNamesString} ${normalisedOperation == 'Add' ? 'to' : 'from' } every task in this milestone?`

			// Just in case openMenu is cleared by selecting a user.
			setTimeout(_ => {
				openMenu(column.id,task.id, true)

				const brainData = {
					suggestion,
					operation: mostRecentOperation,
					userIds: userIdsModifiedOnThisTask,
					isVisible: true					
				}

				setBrainData(brainData)

				this.setState({
					brainData
				})
			},1)
		}
	}

	clickPerson = user => {
		const {
			task,
			hasAi,
			taskActivityHistory,
			taskUpdateCallback,
			updateTask,
			column
		} = this.props

		let userId = user.id

		let columnData = (task.column_data && task.column_data[column.id]) ? copy(task.column_data[column.id]) : []

		let activity = null

		let userIdIndexIfExists = columnData.indexOf(userId)

		if(userIdIndexIfExists !== -1){
			activity = 'REMOVE'
			columnData.splice(userIdIndexIfExists, 1)
		}else{
			activity = 'ADD'
			columnData.push(userId)
		}

		if(hasAi){
			// this is pretty analogous to the 'activities' table, but I guess more immediate. For Hassl brain
			taskActivityHistory.push({
				activity,
				type: 'PERSON',
				taskId: task.id,
				targetId: userId
			})

			this.assessActionableBehaviour()
		}

		updateTask({
			...task,
			column_data: {
				...task.column_data,
				[column.id]: columnData
			}
		}, taskUpdateCallback)
	}

	clickMenu = _ => {
		const {
			isDisabled,
			menuState,
			task,
			openMenu,
			column
		} = this.props

		if(!isDisabled && openMenu){
			if(menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id){
				openMenu(null)
			}else if(task){
				openMenu(column.id,task.id)
			}
		}
	}

	render() {
		const {
			menuState,
			task,
			isDisabled,
			isSingle,
			openMenu,
			peopleData,
			column
		} = this.props

		const {
			brainData
		} = this.state

		const {
			selectedUsersArray,
			allUsersArray,
			taskUsers,
			usersText
		} = peopleData

		let className = 'task-people'

		if(!selectedUsersArray.length){
			className += ' hidden'
		}

		if(isDisabled){
			className += ' disabled'
		}

		// sometimes it's optimistically loaded
		const taskId = task ? task.id : -1

		let isOpened = !!isSingle

		if(menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == taskId){
			className += ' active'

			isOpened = true
		}

		if(isSingle && isDisabled){
			className += ' single-disabled'
		}

		return(
			<a href="javascript:void(0)" className={className} onClick={this.clickMenu}>
				{ (isSingle && isDisabled) ? 
					'No people'
				: null}
				<div className="profile-picture-stack">
					{
						selectedUsersArray && selectedUsersArray.length ?
						selectedUsersArray.map((user, index) => {
							if(index > 2){
								return null
							}

							return(
								<ProfilePicture user={user} key={user.id} isTiny={true} />
							)
						})
						: null
					}
				</div>
				{ !isSingle &&
					<span>
						{ usersText ? usersText : 'Anyone' }
					</span>
				}
				{ task ?
					<div className={'smooth-collapse-container'}>
						<SmoothCollapse 
							heightTransition="0.15s ease" 
							expanded={isOpened}
							className="task-menu-collapse"
						>
							<TaskMenu 
								column={column}
								isDisabled={isDisabled} 
								hasSearch={isDisabled ? false : true} 
								isOpened={isOpened} 
								isSingle={isSingle} 
								dismissCallback={openMenu ? openMenu : _ => {}} 
								type="people" 
								menuItems={allUsersArray} 
								selectedMenuItems={taskUsers} 
								isSelectedCheck={this.isUserIdInTask} 
								selectCallback={this.clickPerson} 
								taskId={task.id} 
							/>
						</SmoothCollapse>
					</div>
				: null }
				{ !isSingle ?
					<BrainModal 
						data={brainData} 
						closeCallback={this.closeBrainModal}
						direction="right"
					/>
				: null }
			</a>
		);
	}

}

const getPeopleData = createSelector(
	[
		state => state.account.entities.users,
		state => getCurrentUser(state),
		(_, props) => props.task,
		(_, props) => props.applicableUsers,
		(_, props) => props.column
	],
	(users, userData, task, applicableUsers, column) => {
		const selectedUsersArray = []
		const allUsersArray = (applicableUsers ? [...applicableUsers] : []).filter(Boolean)

		const taskUsers = (task && task.column_data && task.column_data[column.id]) ? task.column_data[column.id] : []

		// users arrays
		taskUsers.forEach(userId => {
			const userObject = users[userId]

			if(!userObject || !userObject.first_name){
				return
			}

			const applicableUserIfExists = allUsersArray.find(user => {
				return user.id === userId
			})

			if(!applicableUserIfExists){
				allUsersArray.push(userObject)
			}

			userObject && selectedUsersArray.push(userObject)
		})

		selectedUsersArray.sort((a, b) => {
			let firstUserName = a.first_name.toUpperCase()
			let secondUserName = b.first_name.toUpperCase()
			return (firstUserName < secondUserName) ? -1 : (firstUserName > secondUserName) ? 1 : 0
		})

		// copy
		let usersText = ''

		if(selectedUsersArray && selectedUsersArray.length){
			if(selectedUsersArray.find(user => {
				return user.id === userData.id
			})){
				usersText = 'Me';
			}else{
				usersText = selectedUsersArray[0].first_name;
			}

			if(selectedUsersArray.length > 1){
				usersText += ' + '+(selectedUsersArray.length - 1);
			}
		}

		return {
			selectedUsersArray,
			allUsersArray,
			taskUsers,
			usersText
		}
	}
)

const mapStateToProps = (state, ownProps) => {
  return {
	account: getCurrentAccount(state),
	peopleData: getPeopleData(state, ownProps),
    allUsers: state.account.entities.users,
  };
}

export default connect(mapStateToProps, {updateTask})(TaskPeople)



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task-people.jsx